<template>
  <CRow>
    <CCol>
      <ViewExamSolution v-if="exam.status === 'FINISHED'" :exam="exam"/>
      <MultipleQuestion
          v-else-if="exam.type === 'MULTI_CHOICES' && !loadingQ"
          :question="question"
          class="w-100 text-right"
          @add-solution="addSolution"
      />
      <TextQuestion
          v-else-if="exam.type === 'TEXT' && !loadingQ"
          :question="question"
          class="w-100 text-right"
          @add-solution="addSolution"
      />
    </CCol>
    <CCol v-if="!loading && exam.status !== 'FINISHED'" sm="4">
      <CCard>
        <CCardHeader
            class="d-sm-flex justify-content-between align-items-start"
        >
          نکات مهم این آزمون
        </CCardHeader>
        <CCardBody class="d-flex align-items-start text-center h-100">
          <ul v-if="exam.notes.length" class="text-sm text-right gray-700">
            <li v-for="(note, index) in exam.notes" :key="index" class="mt-2">
              {{ note }}
            </li>
          </ul>
          <CAlert v-else class="w-100" color="info">
            نکته ای ثبت نشده است.
          </CAlert>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader
            class="d-sm-flex justify-content-between align-items-start"
        >
          زمان باقیمانده و سؤالات
        </CCardHeader>
        <CCardBody class="d-flex align-items-start text-center h-100">
          <ExamStudentStatusBar
              v-if="!loadingQ"
              :question="question"
              @finish="onFinishExam"
          />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "@/plugins/axios";
import ExamStudentStatusBar from "@/components/Modals/Exam/ExamStudentStatusBar.vue";
import MultipleQuestion from "@/components/studentExam/MultipleQuestion.vue";
import TextQuestion from "@/components/studentExam/TextQuestion.vue";
import Vue from "vue";
import ViewExamSolution from "@/components/Exam/ViewExamSolution";

export default {
  components: {
    ViewExamSolution,
    ExamStudentStatusBar,
    MultipleQuestion,
    TextQuestion,
  },
  name: "showExam",

  data() {
    return {
      loading: false,
      loadingQ: true,
      exam: {notes: []},
      question: {},
    };
  },

  mounted() {
    this.getExam();
  },
  watch: {
    exam(newValue) {
      if (newValue.status === 'ACTIVE') {
        this.getQuestion()
      }
    }
  },
  methods: {
    async getExam() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const {data} = await axios.get(`/exam/${examId}`);
        this.exam = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getQuestion() {
      try {
        this.loadingQ = true;
        const {id: examId} = this.$route.params;
        const {data} = await axios.get(`/exam/${examId}/question/next`);
        this.question = data;
        if (this.question.status !== "OK") {
          console.log(
              "EXAM_FINISHED",
              "QUESTION_STATUS " + this.question.status
          );
          Vue.$toast("آزمون پایان یافت.");
          this.$router.push("/student/exam");
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loadingQ = false;
      }
    },
    async addSolution(form) {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        this.$emit("add-question", form);
        const payload = {
          questionId: this.question.questionId,
          text: form.text,
          fileUrl: form.fileUrl,
        };
        await axios.post(`/exam/${examId}/answer`, payload);
        if (this.question.status === "OK") {
          form = "";
          this.getQuestion();
        } else {
          this.onFinishExam();
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onFinishExam() {
      console.log("EXAM_FINISHED", "TIMER");
      Vue.$toast("آزمون پایان یافت.");
      this.$router.push("/student/exam");
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  min-height: 40vh;
}

.question__card {
  min-height: calc(80vh + 1.5rem);
}

ul {
  padding-inline-start: 20px;
}
</style>